export default __webpack_public_path__ + "static/media/ic-test-paper-creation.e383de0e.svg";